import React from "react";
import './CLoadInProgress.css';
import {ACCEPTED_LOCALES} from "../i18n";
import ApiV0 from "../services/ApiV0";

const toggleLang = newLang => {
    if (!ACCEPTED_LOCALES.includes(newLang)) {
        console.warn(`unable to setup lang to ${newLang}. Accepted languages are ${ACCEPTED_LOCALES}`);
        return;
    }
    ApiV0.changeLang(newLang);// use cookies
}

const CLangToggle = () => {
    return <div>
        <div onClick={toggleLang.bind(this, 'en')}
             className="flag-icon flag-icon-gb">&#160;</div>
        &#160;
        <div onClick={toggleLang.bind(this, 'fr')}
             className="flag-icon flag-icon-fr">&#160;</div>
    </div>;
};

export default CLangToggle;

/*
                           data-tooltip-content="Use English as language"
                           data-tooltip-place="bottom"
                           data-tooltip-wrapper="nav"
                           data-tooltip-content="Utiliser le Français comme langue"
                           data-tooltip-place="bottom"
                           data-tooltip-wrapper="nav"

 */